<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h5 class="col-10 m-0 font-weight-bold text-primary">{{ 'calendar-integration' | translate }}</h5>
    </div>
    <div class="card-body">
        <mat-form-field class="ml-2">
            <mat-select name="calendar" [(ngModel)]="isTax">
                <mat-option [value]="true">
                    Podatki
                </mat-option>
                <mat-option [value]="false">
                    AMMS
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button class="btn btn-primary m-1" (click)="save()">{{ 'save' | translate }}</button>
    </div>
</div>
<div *ngIf="originVal == isTax && isTax==true" class="card shadow mb-4">
    <div class="card-header py-3">
        <h5 class="col-10 m-0 font-weight-bold text-primary">{{ 'tax-reservation-time-window' | translate }}</h5>
    </div>
    <div class="card-body">
        <div class="form-group">
            <div class="input-group">
                <div class="font-weight-bold">{{ 'tax-reservation-before' | translate }}</div>
            </div>
            <div style="display: flex;">
                <input id="taxId" [(ngModel)]="beforeTimePrint" class="form-control" style="max-width: 68px;"><span style="line-height: 38px;">min</span>
            </div>
        </div>
        <div class="form-group">
            <div class="input-group">
                <div class="font-weight-bold">{{ 'tax-reservation-after' | translate }}</div>
            </div>
            <div style="display: flex;">
                <input id="taxId" [(ngModel)]="afterTimePrint" class="form-control" style="max-width: 68px;"><span style="line-height: 38px;">min</span>
            </div>
        </div>
        <button class="btn btn-primary m-1" (click)="save()">{{ 'save' | translate }}</button>
    </div>
</div>
<app-amms-integration *ngIf="originVal == isTax && isTax==false"></app-amms-integration>
<app-tax-integration-config *ngIf="originVal == isTax && isTax==true"></app-tax-integration-config>